import moment from 'moment'

export const SENT_TEXTS_PER_DAY = 1000
export const TEXT_COST_PER_DAY = 0.06

export const SENT_EMAILS_PER_DAY = 250
export const EMAIL_COST_PER_DAY = 0.0

function capByDeliveryWindow(total, perDay, deliveryStartDate, deliveryFinishDate) {
  if (!deliveryFinishDate) {
    return total
  }

  return Math.min(
    moment(deliveryFinishDate).diff(deliveryStartDate, 'days') * perDay,
    total
  )
}

export function getCampaignEstimation({
  deliveryStartDate,
  deliveryFinishDate,
  guestsToText = 0,
  guestsToEmail = 0,
  totalGuestsToReach = 0,
  credits = 0
}) {
  const guestsWillBeReached = capByDeliveryWindow(
    totalGuestsToReach,
    SENT_TEXTS_PER_DAY,
    deliveryStartDate,
    deliveryFinishDate
  )

  const guestsWillBeEmailed = capByDeliveryWindow(
    guestsToEmail,
    SENT_EMAILS_PER_DAY,
    deliveryStartDate,
    deliveryFinishDate
  )

  const guestsWillBeTexted = capByDeliveryWindow(
    guestsToText,
    SENT_TEXTS_PER_DAY,
    deliveryStartDate,
    deliveryFinishDate
  )

  const campaignDurationInDays = Math.floor(guestsWillBeReached / SENT_TEXTS_PER_DAY)

  const campaignCost =
    (guestsWillBeTexted - Math.min(guestsWillBeTexted, credits)) * TEXT_COST_PER_DAY +
    guestsWillBeEmailed * EMAIL_COST_PER_DAY

  return {
    guestsWillBeReached,
    guestsWillBeEmailed,
    guestsWillBeTexted,
    complimentaryTexts: Math.min(credits, guestsWillBeReached),
    campaignCost,
    estimatedEndDate: moment(deliveryStartDate).add(campaignDurationInDays + 1, 'day')
  }
}
